import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2, Ticket, Home, Download, Sparkles } from 'lucide-react';

const SuccessScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const bookingData = location.state?.bookingData || JSON.parse(localStorage.getItem('lastBooking') || '{}');

    return (
        <div className="min-h-screen bg-cream flex items-center justify-center p-6 font-outfit relative overflow-hidden">
             {/* Background Decor */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary/5 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2"></div>

            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bg-white max-w-xl w-full rounded-[3rem] shadow-2xl shadow-primary/5 p-10 md:p-16 text-center border border-primary/10 relative z-10"
            >
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", damping: 12, delay: 0.2 }}
                    className="w-24 h-24 bg-primary/10 text-primary rounded-[2rem] flex items-center justify-center mx-auto mb-8 shadow-sm"
                >
                    <CheckCircle2 size={48} strokeWidth={2.5} />
                </motion.div>

                <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/5 text-primary rounded-full text-[10px] font-black uppercase tracking-[0.2em] mb-6 border border-primary/10">
                    <Sparkles size={12} />
                    Booking Successful
                </div>

                <h1 className="text-4xl md:text-5xl font-playfair font-black text-secondary mb-6 tracking-tight leading-tight">
                    Your Divine Journey <br/> <span className="text-primary italic">is Confirmed!</span>
                </h1>

                <p className="text-secondary/60 font-medium mb-12 max-w-sm mx-auto leading-relaxed text-lg">
                    Your seats have been secured for an unforgettable experience. Your digital pass is ready for retrieval.
                </p>

                <div className="flex flex-col sm:flex-row gap-5">
                    <button
                        onClick={() => navigate('/ticket', { state: { bookingData } })}
                        className="flex-1 bg-primary text-white py-5 rounded-[1.5rem] font-black text-lg flex items-center justify-center gap-3 shadow-xl shadow-primary/20 hover:bg-secondary transition-all transform hover:-translate-y-1"
                    >
                        <Ticket size={22} />
                        View Ticket
                    </button>

                    <button
                        onClick={() => navigate('/')}
                        className="flex-1 bg-white border-2 border-primary/10 text-secondary py-5 rounded-[1.5rem] font-black text-lg flex items-center justify-center gap-3 hover:bg-cream transition-all"
                    >
                        <Home size={22} />
                        Home Hub
                    </button>
                </div>

                <div className="mt-12 pt-10 border-t border-primary/10">
                    <div className="flex flex-col items-center">
                        <button className="flex items-center justify-center gap-3 text-secondary/30 font-black text-[10px] uppercase hover:text-primary transition-colors tracking-[0.3em] mx-auto group">
                            <Download size={18} className="group-hover:translate-y-0.5 transition-transform" />
                            Download Booking Receipt
                        </button>
                        <p className="mt-6 text-[10px] font-black text-secondary/10 uppercase tracking-[0.5em] italic">Rotaract Bhavnagar Youth</p>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default SuccessScreen;
